import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class DropdownOption extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
        isFocused: PropTypes.bool.isRequired,
        children: PropTypes.node.isRequired,
        isSelected: PropTypes.bool.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        isDisabled: PropTypes.bool,
        className: PropTypes.string
    };

    static defaultProps = {
        isDisabled: false,
        className: null
    };

    componentDidMount() {
        this.setFocus();
    }

    componentDidUpdate() {
        this.setFocus();
    }

    setFocus() {
        const { isFocused } = this.props;
        if (isFocused) {
            // setTimeout to force focus call at the end of the call stack
            setTimeout(() => {
                this.button.focus();
            }, 0);
        }
    }

    handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { onClick, value } = this.props;

        onClick(value);
    }

    render() {
        const {
            children,
            isDisabled,
            value,
            isSelected,
            className
        } = this.props;

        const styles = cx(`rec-select-option ${className}`, {
            "rec-select-option-disabled": isDisabled
        });

        return (
            <li
                className={styles}
                role="option"
                aria-label={children}
                aria-selected={isSelected ? "true" : "false"}>
                <button
                    ref={(node) => this.button = node}
                    className="rec-select-option-button"
                    value={value}
                    onClick={this.handleClick}
                    disabled={isDisabled}
                    type="button">
                    {children}
                </button>
            </li>
        );
    }
}